export const TOOLTIP_HEIGHT = 36;
export const TOOLTIP_MARGIN = 8;

export const TOOLTIP_ID = 'tooltip';
